var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25ZM8 2.75C5.10051 2.75 2.75 5.10051 2.75 8C2.75 10.8995 5.10051 13.25 8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75ZM9.46973 5.46973C9.76262 5.17684 10.2374 5.17684 10.5303 5.46973C10.8232 5.76262 10.8232 6.23738 10.5303 6.53027L9.06055 8L10.582 9.52637C10.8223 9.82095 10.8049 10.2557 10.5303 10.5303C10.2557 10.8049 9.82095 10.8223 9.52637 10.582L8 9.06055L6.47363 10.582C6.17905 10.8223 5.74433 10.8049 5.46973 10.5303C5.19513 10.2557 5.17766 9.82094 5.41797 9.52637L6.93945 8L5.46973 6.53027C5.17683 6.23738 5.17683 5.76262 5.46973 5.46973C5.76262 5.17683 6.23738 5.17683 6.53027 5.46973L8 6.93945L9.46973 5.46973Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.71c26e511854380d166aeebd7dc81a89.svg";
export { ForwardRef as ReactComponent };